import tracker from '@weus/joyweb-tracker';

// 埋点配置
export const webLogConfig = {
  module: '8920017', // 奇点分配的ID
  uuid: 'pt_pin', // cookie中的通用唯一标识符
  // TODO 根据环境做判断
  // enable: false, // 是否开启跟踪功能
  MTA: {
    sid: '500707663', // MTA统计用的AppID
    cid: '500707669', // 如果开启自定义事件，此项目为必填
  },
};

// 页面报送
export function trackerPage(pathname) {
  if (window.__qd__) {
    tracker.page(pathname);
  }
}

// 事件报送
export function trackerEvent(name, opts, desc = '') {
  if (name === undefined) {
    console.log('webLog [name] should not be undefined!');
    return false;
  }
  if (opts && typeof opts !== 'object') {
    console.log('webLog [opts] should be Object!');
    return false;
  }
  if (window.__qd__) {
    // track event
    tracker.event({
      name, // 事件名称
      param: opts, // 参数
      desc, // 描述
    });
  }
}
